/** Quill 이 스스로 내는 인라인 style 속성 — 툴바의 color 포맷이 `<span style="color: …">` 를 만든다. */
const QUILL_STYLE_PROPS = new Set(['color', 'background-color']);

/**
 * 상세 설명이 Quill 로 담을 수 없는 HTML 인지. Quill 은 등록 안 된 마크업을 편집기에 올릴 때 버리므로,
 * 그런 본문을 Quill 로 열고 저장하면 표·박스·정렬이 사라진다.
 * 판정 기준은 파이썬 검증기(`.claude/skills/product-detail-page/scripts/_pdp.py` 의 `is_rich_html`)와 같다.
 */
export function isRichHtml(html: string | null | undefined): boolean {
  if (!html) return false;
  if (/<(?:div|table|section|figure)\b/i.test(html)) return true;
  const styleAttr = /\sstyle\s*=\s*["']([^"']*)["']/gi;
  let m: RegExpExecArray | null;
  while ((m = styleAttr.exec(html)) !== null) {
    const props = m[1]
      .split(';')
      .filter((d) => d.includes(':'))
      .map((d) => d.split(':')[0].trim().toLowerCase());
    if (props.some((p) => !QUILL_STYLE_PROPS.has(p))) return true;
  }
  return false;
}

export const RICH_HTML_EDIT_HINT = "'소개' 단계의 원문(HTML) 편집창에서 직접 수정해 주세요.";
export const RICH_HTML_AI_SKIPPED_MESSAGE = `상세 설명이 HTML이라 AI 제안은 적용하지 않았습니다. ${RICH_HTML_EDIT_HINT}`;
export const RICH_HTML_AI_PARTIAL_MESSAGE = `상세 설명은 HTML이라 적용하지 않고, 나머지 AI 제안만 폼에 반영했습니다. ${RICH_HTML_EDIT_HINT}`;

/** 현재 본문이 HTML이면 AI가 낸 description 을 뺀다 — 그대로 덮으면 표·박스 구성이 확인 없이 사라진다. */
export function dropDescriptionOverRichHtml<T extends object>(
  proposal: T,
  currentDescription: string | null | undefined,
): { proposal: Partial<T>; dropped: boolean } {
  const { description, ...rest } = proposal as T & { description?: unknown };
  if (description === undefined || !isRichHtml(currentDescription)) return { proposal, dropped: false };
  return { proposal: rest as Partial<T>, dropped: description !== currentDescription };
}
